import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { saveToStorage, getFromStorage } from '@forvalter/utils/storage';
import { localStorageReferences } from '../utils';

export interface ISurveyState {
    hideSurvey: boolean;
}
export interface ISurveyStore {
    survey: ReturnType<typeof surveySelectorSlice.reducer>;
}
export const surveySelectorSelectors = ({
    survey,
}: ISurveyStore): ISurveyState => survey;

const saveHideSurveyToStorage = createAsyncThunk(
    'survey/saveHideSurveyToStorage',
    async (hideSurvey: boolean) => {
        saveToStorage(localStorageReferences.HIDE_SURVEY, hideSurvey);
        return hideSurvey;
    },
);

const hideSurveyFromStorage = getFromStorage(
    localStorageReferences.HIDE_SURVEY,
) as boolean;

export const surveySelectorSlice = createSlice({
    name: 'surveySelector',
    initialState: {
        hideSurvey: hideSurveyFromStorage,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(saveHideSurveyToStorage.fulfilled, (state, action) => {
            state.hideSurvey = action.payload;
        });
    },
});

export const surveySelectorActions = {
    saveHideSurveyToStorage,
    reducerActions: surveySelectorSlice.actions,
};
